<template>
    <div class="flex items-center text-gray-400">
        <hr class="mr-2 flex-grow border-t border-gray-400" />
        <span class="px-2 text-center">
            <slot></slot>
        </span>
        <hr class="ml-2 flex-grow border-t border-gray-400" />
    </div>
</template>
